__turbopack_context__.v({
  "blok-big-title": "tags-module__5uMMdq__blok-big-title",
  "blok-subtitle": "tags-module__5uMMdq__blok-subtitle",
  "blok-title": "tags-module__5uMMdq__blok-title",
  "product-card__tag": "tags-module__5uMMdq__product-card__tag",
  "product-card__tag__Outlet": "tags-module__5uMMdq__product-card__tag__Outlet",
  "product-card__tag__Salg": "tags-module__5uMMdq__product-card__tag__Salg",
  "product-card__tags": "tags-module__5uMMdq__product-card__tags",
});
